module.exports = __webpack_public_path__ + "static/media/turkey-small.110a3505.gif";